/**
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router'

export const getDeepestActivatedRoute = (activatedRoute: ActivatedRoute): ActivatedRoute =>
  activatedRoute.firstChild ? getDeepestActivatedRoute(activatedRoute.firstChild) : activatedRoute

export const getDeepestRouteSnapshot = (snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot =>
  snapshot.firstChild ? getDeepestRouteSnapshot(snapshot.firstChild) : snapshot

function getMetaTitleKeysFromLeafSnapshot(leaf: ActivatedRouteSnapshot): string[] | undefined {
  let snapshot: ActivatedRouteSnapshot | null = leaf

  while (snapshot) {
    const raw = snapshot.data['metaTitleKeys']
    if (Array.isArray(raw) && raw.length > 0 && raw.every((k) => typeof k === 'string')) {
      return raw as string[]
    }
    snapshot = snapshot.parent
  }

  return undefined
}

/**
 * Reads `data.metaTitleKeys` from the leaf route's ancestors (lazy feature routes attach keys on the parent).
 */
export function getMetaTitleKeysFromActivatedRouteTree(activatedRoute: ActivatedRoute): string[] | undefined {
  const leaf = getDeepestActivatedRoute(activatedRoute)
  return getMetaTitleKeysFromLeafSnapshot(leaf.snapshot)
}

/**
 * Same as {@link getMetaTitleKeysFromActivatedRouteTree} but walks from `Router.routerState.snapshot.root`.
 * Prefer this when the injected `ActivatedRoute` snapshot can lag behind lazy-loaded children.
 */
export function getMetaTitleKeysFromRouterRootSnapshot(root: ActivatedRouteSnapshot): string[] | undefined {
  const leaf = getDeepestRouteSnapshot(root)
  return getMetaTitleKeysFromLeafSnapshot(leaf)
}
